import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { SquareRounded } from "@mui/icons-material";

export function MyListItem(props) {
  const { text, iconColor = "#e369db" } = props;
  const iconSize = {
    xs: "9px",
    sm: "14px",
    ms: "16px",
    lg: "18px",
    xl: "20px",
  };
  return (
    <ListItem sx={{ p: 0 }}>
      <ListItemIcon
        sx={{
          color: iconColor,
          minWidth: { xs: 20, sm: 24, md: 32, lg: 32, xl: 32 },
        }}
      >
        <SquareRounded sx={{ fontSize: iconSize }} />
      </ListItemIcon>
      <ListItemText
        primary={text}
        primaryTypographyProps={{
          p: 0,
          fontSize: { xs: 16, sm: 16, md: 18, lg: 22, xl: 24 },
          variant: "body1",
        }}
        sx={{ margin: 0 }}
      />
    </ListItem>
  );
}
